import React from 'react';
import styled from 'styled-components';
import { Submitted } from '@mummssoftware/utils/constants';
import { on, definedAndPrefix, ifFirstParamDefined, nameWithCredentials, YYYYMMDDtoMMDDYYYY } from '@mummssoftware/utils/formatters';
import defaults from '../translations/en.json';
const SignatureDiv = styled.div.withConfig({
  displayName: "FajitaSignature__SignatureDiv",
  componentId: "sc-1395ilq-0"
})(["color:", ";font-size:1em;padding-right:5px;padding-top:1px;padding-bottom:1px;"], props => props.theme.palette.text.primary);
const ElectronicallySignedText = defaults.electronicallySignedBy;
const ElectronicallySignedBy = definedAndPrefix(ElectronicallySignedText);
const ElectronicallySignedOnBy = ifFirstParamDefined((d, provider) => `${ElectronicallySignedBy(provider)}${on(d)}`);
export const FajitaSignature = ({
  formData: form
}) => {
  const modifierName = nameWithCredentials(form.modifiedpersonfirstname, form.modifiedpersonlastname, form.modifiedpersoncredentials);
  const isSubmitted = form.status === Submitted;
  const signatureText = isSubmitted ? ElectronicallySignedOnBy(YYYYMMDDtoMMDDYYYY(form.modifieddate), modifierName) : '';
  return /*#__PURE__*/React.createElement(SignatureDiv, null, signatureText);
};